import { useFormatedVolume } from '@common/hooks/useFormatedVolume';
import { Box, Text } from '@radix-ui/themes';

interface FormatedVolumeProps {
    volume: number;
    options?: Intl.NumberFormatOptions;
}

export const FormatedVolume = ({ volume, options }: FormatedVolumeProps) => {
    const { formatVolume } = useFormatedVolume(options);
    return (
        <Box asChild>
            <Text align={'right'}>{formatVolume(volume)}</Text>
        </Box>
    );
};
